"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var BrandGwsGameProviderEditor = /** @class */ (function (_super) {
    __extends(BrandGwsGameProviderEditor, _super);
    function BrandGwsGameProviderEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandGwsGameProviderEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    gws_gameprovider_id: _item.gws_gameprovider_id,
                    gws_gameprovider_title: _item.gws_gameprovider_title,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    gws_gameprovider_avail: [],
                    app_currency_avail: []
                });
            }
        }
        else {
            this.setState({
                gws_gameprovider_id: 0,
                gws_gameprovider_title: "",
                gws_gameprovider_avail: [],
                app_currency_id: 0,
                app_currency_title: "",
                app_currency_avail: []
            });
        }
        this.SID_AG = this.props.dataGwsGameProvider.Subscribe("*", function (id, data) {
            _this.setState({ gws_gameprovider_avail: data.data });
        });
        this.SID_AC = this.props.dataAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ app_currency_avail: data.data });
        });
        this.props.dataGwsGameProvider.LoadData();
        this.props.dataAppCurrency.LoadData();
        this.doReSetRules();
    };
    BrandGwsGameProviderEditor.prototype.componentWillUnmount = function () {
        this.props.dataGwsGameProvider.UnSubscribe(this.SID_AG);
        this.props.dataAppCurrency.UnSubscribe(this.SID_AC);
    };
    BrandGwsGameProviderEditor.prototype.doReSetRules = function () {
        this.setState({
            gws_gameprovider_rules: { isError: false },
            app_currency_rules: { isError: false }
        });
    };
    BrandGwsGameProviderEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.gws_gameprovider_id <= 0) || (this.state.gws_gameprovider_title.length === 0)) {
            this.setState({ gws_gameprovider_rules: { isError: true, errorMessage: "Поле [геймпровайдер шлюз] не выбран!" } });
            return false;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Поле [валюта] не выбрано!" } });
            return false;
        }
        return true;
    };
    /*private OnUpdateDataClick() {

        if (this.isDataValid()) {

            this.props.data.EditData({

                key: this.props.record.key,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                app_currency_id: this.state.app_currency_id

            }, () => {
                notificationHelper.ShowTextTopRightInfoNotify("Геймпровайдер шлюз изменен!");
            })

        }

    }*/
    BrandGwsGameProviderEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.state.app_currency_id,
                brand_id: this.props.rootRecord.key,
                gws_gameprovider_id: this.state.gws_gameprovider_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Геймпровайдер шлюз добавлен!");
            });
        }
    };
    BrandGwsGameProviderEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandGwsGameProviderEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить геймпровайдер шлюз";
        }
        else {
            return "Изменить геймпровайдер шлюз";
        }
    };
    BrandGwsGameProviderEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер шлюз :", placeholder: "Выберите геймпровайдер шлюз" }, value: { key: this.state.gws_gameprovider_id, value: this.state.gws_gameprovider_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_id: newVal.key,
                        gws_gameprovider_title: newVal.value,
                        gws_gameprovider_rules: { isError: false }
                    });
                }, items: this.state.gws_gameprovider_avail, required: true, rules: this.state.gws_gameprovider_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта :", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.state.app_currency_avail, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { /*btnEdit: "Сохранить",*/ btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return BrandGwsGameProviderEditor;
}(React.Component));
exports.default = BrandGwsGameProviderEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/gateways/gameprovider/BrandGwsGameProviderEditor.tsx
// module id = 1763
// module chunks = 0